export default "__VITE_ASSET__BxnQBjab__"